import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-container">
        <div className="logo">
          <a className="navbar-brand page-scroll" href="/">
            <img src="/logo192.png" alt="RO Service Center" />
            <span style={{ color: "white" }}>RO Service Center</span>
          </a>
        </div>

        {/* Desktop Menu */}
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <a href="#services">Services</a>
          <a href="#pricing">Pricing</a>
          <Link to="/faq-support">Support</Link>
          <Link to="/privacy-policy">Privacy</Link>
        </nav>

        <div className="nav-actions">
          <a href="tel:9031062015" className="nav-phone">
            📞 +91 9031062015
          </a>
          <a href="#contact" className="nav-book">
            Book Service
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="menu-btn"
          onClick={() => setMenuOpen(true)}
        >
          ☰
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
          <button
            className="close-btn"
            onClick={() => setMenuOpen(false)}
          >
            ✕
          </button>

          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>

          <a href="#services" onClick={() => setMenuOpen(false)}>
            Services
          </a>

          <a href="#pricing" onClick={() => setMenuOpen(false)}>
            Pricing
          </a>

          <Link
            to="/faq-support"
            onClick={() => setMenuOpen(false)}
          >
            Support
          </Link>

          <Link
            to="/privacy-policy"
            onClick={() => setMenuOpen(false)}
          >
            Privacy
          </Link>

          <a href="tel:9031062015" className="nav-phone">
            📞 +91 9031062015
          </a>

          <a href="#contact" className="nav-book">
            Book Service
          </a>
        </div>
      </div>
    </header>
  );
}